import apiClient from "./axiosInstance"
import {
  ApplicationDoc,
  StatePayload,
  AlterStateRequest,
  AlterStateResponse,
} from "../types/applicationData"
import { getErrorStatus, getErrorMessage } from "../types/error"

export const TAfindApplicationByCampaignId = async (campaign_id: any, state: string) => {
  const response = await apiClient.get(
    `/admin/application/campaign_id/${campaign_id}?state=${state}`,
  )
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Find User failed")
  }
}

export const TAfindApplicationByCampaignIdPaginated = async (
  campaign_id: string,
  state: string,
  page: number,
  perPage: number,
) => {
  const response = await apiClient.get(
    `/admin/application/campaign_id/${campaign_id}?state=${state}&page=${page}&perPage=${perPage}`,
  )
  if (response.status === 200) {
    return response.data
  }
  throw new Error("Find Applications failed")
}

export const TACreateApplication = async (
  applicationUser: {
    tiktok: any
    user_id: any
    insta_username: any
    age: any
    gender: any
    verification: any
    state: any
    school_type?: any
    school_name?: any
    city?: any
    country?: any
    language?: any
    currency?: any
    job?: any
    birthday?: any
    insta: any
    price_user: any
    price_brand: any
    tiktok_username: any
  },
  campaign_id: string,
  selectedState: string,
  campaign_type: string,
) => {
  const response = await apiClient.post(
    "/admin/application/create",
    {
      user: applicationUser,
      campaign_id: campaign_id,
      state: selectedState,
      campaign_type: campaign_type,
    },
    {
      timeout: 120000,
      headers: {
        "Content-Type": "application/json",
      },
    },
  )
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Creating application failed")
  }
}

export const TAalterApplicationState = async (
  applicationData: Partial<ApplicationDoc> & { _id: string },
  new_state: string,
  new_state_payload: StatePayload,
): Promise<AlterStateResponse> => {
  try {
    const requestBody: AlterStateRequest = {
      applicationData,
      new_state,
      new_state_payload,
    }

    const response = await apiClient.post<AlterStateResponse>(
      "/admin/application/update",
      requestBody,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    )

    if (response.status === 200) {
      return response.data
    } else {
      throw new Error("State alteration failed")
    }
  } catch (error: unknown) {
    if (getErrorStatus(error) === 400) {
      throw new Error(getErrorMessage(error) || "Invalid state transition")
    } else if (getErrorStatus(error) === 500) {
      throw new Error("Database error occurred")
    } else {
      throw new Error("State alteration failed")
    }
  }
}

export const TAassignUserToApplication = async (id: string, data: any) => {
  const response = await apiClient.post(
    `/admin/application/assign-user/${id}`,
    { user_id: data },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  )
  return response
}

export const TAfindApplications = async (query: any) => {
  const response = await apiClient.get(`/admin/application/user_applications?${query}`, {})

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Find User failed")
  }
}

export const TAgetAllApplications = async (
  page: number,
  perPage: number,
  params: any,
  sortBy: string,
  sortOrder: boolean,
  signal?: AbortSignal,
) => {
  const response = await apiClient.get(
    `/admin/application/all_applications?${params}&page=${page}&perPage=${perPage}&sortBy=${sortBy}&sortOrder=${sortOrder}`,
    { signal },
  )
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Find User failed")
  }
}

export const TAgetApplications = async (
  state: string,
  page: number,
  perPage: number,
  sortBy?: string,
  sortOrder?: boolean,
  params?: any,
  signal?: AbortSignal,
) => {
  const response = await apiClient.get(
    `/admin/application/applications?state=${state}&page=${page}&perPage=${perPage}&sortBy=${sortBy}&sortOrder=${sortOrder}&${params}`,
    { signal },
  )
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Find User failed")
  }
}

export const TAapplicationIsCalled = async (
  id: string,
  is_called: boolean,
  is_called_by: string,
) => {
  const response = await apiClient.post(`/admin/application/is-called/${id}`, {
    is_called,
    is_called_by,
  })

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Find User failed")
  }
}

export const TAapplicationInfoState = async (id: string, info_state: string) => {
  const response = await apiClient.post(`/admin/application/info-state/${id}`, {
    info_state,
  })

  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Find User failed")
  }
}

export const TAgetAgencyApplications = async (
  page: number,
  perPage: number,
  sortBy: string,
  sortOrder: boolean,
  state: string,
  signal?: AbortSignal,
) => {
  const response = await apiClient.get(
    `/admin/application/agency?state=${state}&page=${page}&perPage=${perPage}&sortBy=${sortBy}&sortOrder=${sortOrder}`,
    { signal },
  )
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Find User failed")
  }
}

export const TAgetStateStats = async (
  startDate?: string,
  endDate?: string,
  signal?: AbortSignal,
) => {
  const params = new URLSearchParams()
  if (startDate) {
    params.append("startDate", startDate)
  }
  if (endDate) {
    params.append("endDate", endDate)
  }

  const response = await apiClient.get(`/admin/application/state-stats?${params.toString()}`, {
    signal,
  })
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("State statistics fetch failed")
  }
}

export const TAsetShareDate = async (application_id: string, date: Date, signal?: AbortSignal) => {
  const response = await apiClient.put(
    "/admin/application/set-share-date",
    { application_id, date },
    { signal },
  )
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Find User failed")
  }
}

export const TAsetIsWpMessaged = async (
  application_id: string,
  is_whatsapp_messaged: boolean,
  signal?: AbortSignal,
) => {
  const response = await apiClient.post(
    "/admin/application/is-whatsapp-messaged",
    { application_id, is_whatsapp_messaged },
    { signal },
  )
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Find User failed")
  }
}

export const TAsetDelayReason = async (
  application_id: string,
  delay_reason_code: string,
  delay_reason_note: string,
  signal?: AbortSignal,
) => {
  const response = await apiClient.post(
    "/admin/application/delay-reason",
    { application_id, delay_reason_code, delay_reason_note },
    { signal },
  )
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Find User failed")
  }
}

export const TAsetAddress = async (application_id: string, address: any, signal?: AbortSignal) => {
  const response = await apiClient.post(
    "/admin/application/set-address",
    { application_id, address },
    { signal },
  )
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Address update failed")
  }
}

export const TAsetPricing = async (
  price_user: number,
  price_brand: number,
  application_id: string,
  signal?: AbortSignal,
) => {
  const response = await apiClient.post(
    "/admin/application/set-pricing",
    { price_user, price_brand, application_id },
    { signal },
  )
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Pricing update failed")
  }
}

export const TAsetStatePayload = async (
  application_id: string,
  post_url: string,
  signal?: AbortSignal,
) => {
  const response = await apiClient.post(
    "/admin/application/set-state-payload",
    { application_id, post_url },
    { signal },
  )
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("State payload update failed")
  }
}

export const TAuploadUserPayload = async (
  id: any,
  data: any,
  type: string,
  onUploadProgress?: (progressEvent: any) => void,
) => {
  const response = await apiClient.post(`/admin/application/upload/${id}?type=${type}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    timeout: 600000, // 10 minutes timeout for large file uploads
    onUploadProgress: onUploadProgress,
  })
  return response
}
export const TAinitUpload = async (fileName: string, type: string, contentType?: string) => {
  const response = await apiClient.post(
    "/admin/application/upload/multipart/init",
    {},
    {
      params: {
        fileName,
        type,
        contentType,
      },
    },
  )
  return response
}

export const TAsignPart = async (uploadId: string, key: string, partNumber: number) => {
  const response = await apiClient.get("/admin/application/upload/multipart/sign-part", {
    params: {
      uploadId,
      key,
      partNumber,
    },
  })
  return response
}

export const TAcompleteUpload = async (
  uploadId: string,
  key: string,
  parts: { PartNumber: number; ETag: string }[],
) => {
  const requestData = {
    uploadId,
    key,
    parts,
  }

  const response = await apiClient.post("/admin/application/upload/multipart/complete", requestData)
  return response
}

export const TAlistParts = async (uploadId: string, key: string) => {
  const response = await apiClient.get("/admin/application/upload/multipart/list-parts", {
    params: {
      uploadId,
      key,
    },
  })
  return response
}

export const TAabortUpload = async (uploadId: string, key: string) => {
  const response = await apiClient.post("/admin/application/upload/multipart/abort", {
    uploadId,
    key,
  })
  return response
}

export const TAgetBrandApplications = async (signal?: AbortSignal) => {
  const response = await apiClient.get("/admin/application/brand-applications", { signal })
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Brand applications fetch failed")
  }
}

export const TAdowngradeApplicationState = async (application_id: string, signal?: AbortSignal) => {
  const response = await apiClient.post(`/admin/application/downgrade-state/${application_id}`, {
    signal,
  })
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Brand applications fetch failed")
  }
}

export const TAcanceledStateChange = async (application_id: string, signal?: AbortSignal) => {
  const response = await apiClient.post(
    `/admin/application/canceled-state-change/${application_id}`,
    {
      signal,
    },
  )
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Brand applications fetch failed")
  }
}

export const TAupdateApplicationMetrics = async (
  id: string,
  post_url: string,
  signal?: AbortSignal,
) => {
  const response = await apiClient.post(
    "/admin/application/update-application-metrics",
    { id, post_url },
    { signal },
  )
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Application metrics update failed")
  }
}
